/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper';
import * as Permission from "../util/Permission";

export default declareEntity({
    entity: "manualRelations",
    graphQL: "ManualRelation",
    name: "Manual relations",
    storageType: 'central',
    writePermission: [
        Permission.PERM_EDIT_CHANNEL,
    ],
    fields: (types) => { return {
        id: {
            name: "Manual Relation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        user: {
            name: "User",
            to: () => types['users'],
            type: "relation",
            defaultValue: (user) => {
                return user['id'];
            },
            required: true
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (organisation) => {
                return organisation['organisation_id'];
            },
            required: true,
            parent: true,
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        channelFrom: {
            name: "Source Application",
            type: "relation",
            to: () => types['channels'],
            defaultValue: (organisation) => {
                return organisation['channel_id'];
            },
            required: true
        },
        channelTo: {
            name: "Target Application",
            type: "relation",
            to: () => types['channels'],
            required: true
        },
        entityDefFrom: {
            name: "Source Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (project) => {
                return project['entityDef_id'];
            },
            required: true
        },
        entityDefTo: {
            name: "Target Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (project) => {
                return project['entityDef_id'];
            },
            required: true
        },

        fromId: {
            name: "Source ID",
            type: "string",
            required: true
        },

        toId: {
            name: "Target ID",
            type: "string",
            required: true
        },

        fromAttrIds: {
            name: "Other Source IDs",
            type: "object",
            defaultValue: {},
            required: true
        },

        toAttrIds: {
            name: "Other Target IDs",
            type: "object",
            defaultValue: {},
            required: true
        },
        weight: {
            name: "Relation Weight",
            type: "int",
            defaultValue: 100,
            required: true
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        author: {
            name: "Created By",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
    }; },
});
